/* ========================================
   ONLINE RECHNER - SEVA-tec
   Reads i18n from window.SEVA_I18N (injected by Liquid template)
   ======================================== */

// Fallback i18n (English defaults): greift je Schlüssel, falls die Liquid-Brücke
// fehlt, einen Schlüssel nicht liefert oder eine Übersetzung fehlt
const T_FALLBACK = {
  errors: {
    missing_inputs: "Please fill in all required fields",
    min_two_values: "Please enter at least two values.",
    min_three_of_four: "Please enter at least three of four values.",
    leave_one_empty: "Please leave exactly one field empty for calculation.",
    min_six_of_seven: "Please enter at least six of seven values.",
    min_five_of_six: "Please enter at least five of six values.",
    greater_zero: "Value must be greater than 0.",
    between_0_1: "Value must be between 0 and 1.",
    not_zero: "Value must not be 0.",
    cos_phi_range: "cos φ must be between 0 and 1.",
    sin_phi_range: "sin φ must be between 0 and 1.",
    cos_phi_gt_1: "Invalid input: cos φ would be greater than 1.",
    sin_phi_gt_1: "Invalid input: sin φ would be greater than 1.",
    p_gt_s: "Active power cannot be greater than apparent power.",
    q_gt_s: "Reactive power cannot be greater than apparent power.",
    voltage_drop_range: "Voltage drop must be between 0 and 100%.",
    invalid_inputs: "Invalid input values.",
    voltage_current_gt_zero: "Voltage and current must be greater than 0.",
    current_cos_gt_zero: "Current and cos φ must be greater than 0.",
    voltage_cos_gt_zero: "Voltage and cos φ must be greater than 0.",
    current_sin_gt_zero: "Current and sin φ must be greater than 0.",
    voltage_sin_gt_zero: "Voltage and sin φ must be greater than 0.",
    current_gt_zero: "Current must be greater than 0.",
    voltage_gt_zero: "Voltage must be greater than 0.",
    resistance_gt_zero: "Resistance must be greater than 0.",
    power_gt_zero: "Power must be greater than 0.",
    torque_gt_zero: "Torque must be greater than 0.",
    speed_gt_zero: "Speed must be greater than 0.",
    time_gt_zero: "Time must be greater than 0.",
    cos_gt_zero: "cos φ must be greater than 0.",
    sin_gt_zero: "sin φ must be greater than 0.",
    apparent_gt_zero: "Apparent power must be greater than 0.",
    sync_speed_gt_zero: "Synchronous speed must be greater than 0.",
    slip_lt_100: "Slip must be less than 100%.",
    efficiency_range: "Efficiency must be between 0 and 100%.",
    eff_new_gt_old: "New efficiency must be higher than old efficiency.",
    all_required: "Please enter all values."
  },
  labels: {
    power: "Power", voltage: "Voltage", current: "Current", resistance: "Resistance",
    work: "Work", time: "Time", apparent_power: "Apparent Power", active_power: "Active Power",
    reactive_power: "Reactive Power", torque: "Torque", speed: "Speed", rotor_speed: "Rotor Speed",
    sync_speed: "Sync Speed", slip: "Slip", cross_section: "Cross-section", max_current: "Max. Current",
    max_length: "Max. Length", voltage_drop: "Voltage Drop", conductivity: "Conductivity",
    cos_phi: "cos φ", sin_phi: "sin φ"
  },
  energy: {
    annual_saving: "Annual Saving", cost_saving: "Annual Cost Saving",
    payback: "Payback Time", years: "years"
  },
  units: {
    kilowatt: "kW", volt: "V", ampere: "A", ohm: "Ω", joule: "J", second: "s",
    kva: "kVA", kvar: "kvar", newton_meter: "Nm", rpm: "rpm", mm2: "mm²",
    percent: "%", conductivity: "m/(Ω·mm²)", meter: "m"
  }
};

const T = (function (source) {
  const merged = {};
  Object.keys(T_FALLBACK).forEach(group => {
    merged[group] = Object.assign({}, T_FALLBACK[group]);
    const translated = source && source[group];
    if (!translated) return;
    Object.keys(translated).forEach(key => {
      const value = translated[key];
      if (typeof value === 'string' && value.trim() !== '' && !/translation missing/i.test(value)) {
        merged[group][key] = value;
      }
    });
  });
  return merged;
})(window.SEVA_I18N);

/* ========================================
   ACCORDION FUNCTIONALITY
   ======================================== */

function toggleAccordion(header) {
  const body = header.nextElementSibling;
  const isActive = header.classList.contains('active');

  // Nur auf- und zuklappen; welcher Rechner sichtbar ist, entscheiden allein die Links
  document.querySelectorAll('.accordion-header').forEach(h => {
    h.classList.remove('active');
    h.nextElementSibling.classList.remove('active');
  });
  if (!isActive) {
    header.classList.add('active');
    body.classList.add('active');
  }
}

/* ========================================
   CALCULATOR DISPLAY & URL HANDLING
   ======================================== */

// Einzelseite einer Rechnergruppe (data-calculator-group) oder Übersicht (ohne Attribut)
const RECHNER_SECTION = document.querySelector('.online-rechner-section');
const RECHNER_GROUP = RECHNER_SECTION ? (RECHNER_SECTION.dataset.calculatorGroup || '') : '';

// Rechner (oder Kategorieseite) anzeigen, Sidebar-Eintrag und Akkordeon folgen.
// Die Adresse setzt der Browser: alle Links sind echte Links (#rechner-id bzw. Einzelseite#rechner-id).
function showCalculator(calculatorId) {
  const calculator = calculatorId && document.getElementById(calculatorId);
  if (!calculator || !calculator.classList.contains('rechner-calculator')) return false;

  document.querySelectorAll('.rechner-calculator').forEach(calc => calc.classList.remove('active'));
  calculator.classList.add('active');
  markSidebar(calculatorId);

  // Scroll to top on mobile
  if (window.innerWidth < 992) {
    calculator.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  return true;
}

function markSidebar(calculatorId) {
  document.querySelectorAll('.rechner-list a').forEach(link => link.classList.remove('active'));
  const activeLink = calculatorId && document.querySelector(`.rechner-list a[data-calculator="${calculatorId}"]`);
  if (!activeLink) return;
  activeLink.classList.add('active');
  const accordionBody = activeLink.closest('.accordion-body');
  if (accordionBody) {
    accordionBody.previousElementSibling.classList.add('active');
    accordionBody.classList.add('active');
  }
}

function showFromHash() {
  const hashId = decodeURIComponent(window.location.hash.slice(1));
  return hashId ? showCalculator(hashId) : false;
}

window.addEventListener('hashchange', showFromHash);

// Load calculator from URL on page load
window.addEventListener('DOMContentLoaded', () => {
  // Alte Adressen der Übersicht (?calculator=id) weiter bedienen, Adresse auf #id umschreiben
  const params = new URLSearchParams(window.location.search);
  const legacyId = params.get('calculator');
  if (legacyId && !window.location.hash && document.getElementById(legacyId)) {
    params.delete('calculator');
    const query = params.toString();
    window.history.replaceState({}, '', window.location.pathname + (query ? '?' + query : '') + '#' + legacyId);
  }

  if (showFromHash()) return;

  if (RECHNER_GROUP) {
    // Einzelseite: Startrechner ist serverseitig aktiv, nur Sidebar markieren
    markSidebar(RECHNER_SECTION.dataset.calculatorStart);
  } else {
    // Übersicht: Startseite ist serverseitig aktiv, erstes Akkordeon aufklappen
    const firstAccordion = document.querySelector('.accordion-header');
    if (firstAccordion) toggleAccordion(firstAccordion);
  }
});

/* ========================================
   HELPER FUNCTIONS
   ======================================== */

function showResult(resultId, value, unit = '') {
  const resultBox = document.getElementById(resultId);
  if (resultBox) {
    const valueSpan = resultBox.querySelector('.result-value');
    if (valueSpan) {
      valueSpan.textContent = `${value} ${unit}`;
    }
    resultBox.classList.add('active');
  }
}

function showError(errorId, message) {
  const errorBox = document.getElementById(errorId);
  if (errorBox) {
    const errorP = errorBox.querySelector('p');
    if (errorP) {
      errorP.textContent = message;
    }
    errorBox.classList.add('active');
  }
}

function hideResult(resultId) {
  const resultBox = document.getElementById(resultId);
  if (resultBox) {
    resultBox.classList.remove('active');
  }
}

function hideError(errorId) {
  const errorBox = document.getElementById(errorId);
  if (errorBox) {
    errorBox.classList.remove('active');
  }
}

function parseNumber(value) {
  if (!value || value.trim() === '') return null;
  const parsed = parseFloat(value.replace(',', '.'));
  return isNaN(parsed) ? null : parsed;
}

// Dezimaltrennzeichen: von den Shopsprachen schreibt nur Englisch einen Punkt
const RECHNER_DECIMAL_SEP = /^en\b/i.test(document.documentElement.lang || '') ? '.' : ',';

function formatNumber(value, decimals = 2) {
  return value.toFixed(decimals).replace('.', RECHNER_DECIMAL_SEP);
}

function setCalculatedField(fieldId, value, decimals = 2) {
  const field = document.getElementById(fieldId);
  if (field) {
    field.value = formatNumber(value, decimals);
    field.classList.add('calculated');
  }
}

function clearCalculatedFields(formElement) {
  if (formElement) {
    formElement.querySelectorAll('.form-control.calculated').forEach(f => f.classList.remove('calculated'));
  }
}

/* ========================================
   INPUT VALIDATION
   ======================================== */

function rechnerFail(errorId, errorKey) {
  showError(errorId, `❌ ${T.errors[errorKey]}`);
  return false;
}

// Genau ein Feld bleibt leer: alle gefüllt → leave_one_empty, mehr als eins leer → missing_inputs
function checkOneEmpty(errorId, values) {
  const filled = values.filter(v => v !== null).length;
  if (filled === values.length) return rechnerFail(errorId, 'leave_one_empty');
  if (filled < values.length - 1) return rechnerFail(errorId, 'missing_inputs');
  return true;
}

// Regeln [wert, gültig?, meldung] für ausgefüllte Felder; die erste verletzte Regel gewinnt
function checkInputs(errorId, rules) {
  for (const [value, isValid, errorKey] of rules) {
    if (value !== null && !isValid(value)) return rechnerFail(errorId, errorKey);
  }
  return true;
}

// Letzte Sicherung: nur endliche Ergebnisse anzeigen
function checkResult(errorId, result) {
  return Number.isFinite(result) || rechnerFail(errorId, 'invalid_inputs');
}

const gtZero = v => v > 0;
const factorRange = v => v > 0 && v <= 1;
const percentRange = v => v > 0 && v <= 100;

function readField(fieldId) {
  return parseNumber(document.getElementById(fieldId).value);
}

function startCalculation(calculatorId, errorId, resultId) {
  hideError(errorId);
  hideResult(resultId);
  clearCalculatedFields(document.getElementById(calculatorId).querySelector('.calculator-form'));
}

/* ========================================
   CALCULATOR FUNCTIONS - ALLE 18 RECHNER
   ======================================== */

// 1. DC POWER: P = U × I
function calculateDcPower() {
  const E = 'dc_power_error';
  startCalculation('dc_power', E, 'dc_power_result');
  const p = readField('dc_power_p'), u = readField('dc_power_u'), i = readField('dc_power_i');

  if (!checkOneEmpty(E, [p, u, i])) return;
  if (!checkInputs(E, [[p, gtZero, 'power_gt_zero'], [u, gtZero, 'voltage_gt_zero'], [i, gtZero, 'current_gt_zero']])) return;

  let result, text;
  if (p === null) {
    result = (u * i) / 1000;
    if (!checkResult(E, result)) return;
    setCalculatedField('dc_power_p', result);
    text = `${T.labels.power} = ${formatNumber(result)} ${T.units.kilowatt}`;
  } else if (u === null) {
    result = (p * 1000) / i;
    if (!checkResult(E, result)) return;
    setCalculatedField('dc_power_u', result);
    text = `${T.labels.voltage} = ${formatNumber(result)} ${T.units.volt}`;
  } else {
    result = (p * 1000) / u;
    if (!checkResult(E, result)) return;
    setCalculatedField('dc_power_i', result);
    text = `${T.labels.current} = ${formatNumber(result)} ${T.units.ampere}`;
  }
  showResult('dc_power_result', text, '');
}

// 2. DC RESISTANCE: P = I² × R
function calculateDcResistance() {
  const E = 'dc_resistance_error';
  startCalculation('dc_resistance', E, 'dc_resistance_result');
  const p = readField('dc_resistance_p'), i = readField('dc_resistance_i'), r = readField('dc_resistance_r');

  if (!checkOneEmpty(E, [p, i, r])) return;
  if (!checkInputs(E, [[p, gtZero, 'power_gt_zero'], [i, gtZero, 'current_gt_zero'], [r, gtZero, 'resistance_gt_zero']])) return;

  let result, text;
  if (p === null) {
    result = (i * i * r) / 1000;
    if (!checkResult(E, result)) return;
    setCalculatedField('dc_resistance_p', result);
    text = `${T.labels.power} = ${formatNumber(result)} ${T.units.kilowatt}`;
  } else if (i === null) {
    result = Math.sqrt((p * 1000) / r);
    if (!checkResult(E, result)) return;
    setCalculatedField('dc_resistance_i', result);
    text = `${T.labels.current} = ${formatNumber(result)} ${T.units.ampere}`;
  } else {
    result = (p * 1000) / (i * i);
    if (!checkResult(E, result)) return;
    setCalculatedField('dc_resistance_r', result);
    text = `${T.labels.resistance} = ${formatNumber(result)} ${T.units.ohm}`;
  }
  showResult('dc_resistance_result', text, '');
}

// 3. DC VOLTAGE: P = U² / R
function calculateDcVoltage() {
  const E = 'dc_voltage_error';
  startCalculation('dc_voltage', E, 'dc_voltage_result');
  const p = readField('dc_voltage_p'), u = readField('dc_voltage_u'), r = readField('dc_voltage_r');

  if (!checkOneEmpty(E, [p, u, r])) return;
  if (!checkInputs(E, [[p, gtZero, 'power_gt_zero'], [u, gtZero, 'voltage_gt_zero'], [r, gtZero, 'resistance_gt_zero']])) return;

  let result, text;
  if (p === null) {
    result = (u * u / r) / 1000;
    if (!checkResult(E, result)) return;
    setCalculatedField('dc_voltage_p', result);
    text = `${T.labels.power} = ${formatNumber(result)} ${T.units.kilowatt}`;
  } else if (u === null) {
    result = Math.sqrt(p * 1000 * r);
    if (!checkResult(E, result)) return;
    setCalculatedField('dc_voltage_u', result);
    text = `${T.labels.voltage} = ${formatNumber(result)} ${T.units.volt}`;
  } else {
    result = (u * u) / (p * 1000);
    if (!checkResult(E, result)) return;
    setCalculatedField('dc_voltage_r', result);
    text = `${T.labels.resistance} = ${formatNumber(result)} ${T.units.ohm}`;
  }
  showResult('dc_voltage_result', text, '');
}

// 4. MECHANICAL POWER: P = W / t
function calculateMechanicalPower() {
  const E = 'mechanical_power_error';
  startCalculation('mechanical_power', E, 'mechanical_power_result');
  const p = readField('mechanical_power_p'), w = readField('mechanical_power_w'), t = readField('mechanical_power_t');

  if (!checkOneEmpty(E, [p, w, t])) return;
  if (!checkInputs(E, [[p, gtZero, 'power_gt_zero'], [w, gtZero, 'greater_zero'], [t, gtZero, 'time_gt_zero']])) return;

  let result, text;
  if (p === null) {
    result = (w / t) / 1000;
    if (!checkResult(E, result)) return;
    setCalculatedField('mechanical_power_p', result);
    text = `${T.labels.power} = ${formatNumber(result)} ${T.units.kilowatt}`;
  } else if (w === null) {
    result = p * 1000 * t;
    if (!checkResult(E, result)) return;
    setCalculatedField('mechanical_power_w', result, 0);
    text = `${T.labels.work} = ${formatNumber(result, 0)} ${T.units.joule}`;
  } else {
    result = w / (p * 1000);
    if (!checkResult(E, result)) return;
    setCalculatedField('mechanical_power_t', result);
    text = `${T.labels.time} = ${formatNumber(result)} ${T.units.second}`;
  }
  showResult('mechanical_power_result', text, '');
}

// 5. AC APPARENT POWER: S = U × I
function calculateAcApparentPower() {
  const E = 'ac_apparent_error';
  startCalculation('ac_apparent_power', E, 'ac_apparent_result');
  const s = readField('ac_apparent_s'), u = readField('ac_apparent_u'), i = readField('ac_apparent_i');

  if (!checkOneEmpty(E, [s, u, i])) return;
  if (!checkInputs(E, [[s, gtZero, 'apparent_gt_zero'], [u, gtZero, 'voltage_gt_zero'], [i, gtZero, 'current_gt_zero']])) return;

  let result, text;
  if (s === null) {
    result = (u * i) / 1000;
    if (!checkResult(E, result)) return;
    setCalculatedField('ac_apparent_s', result);
    text = `${T.labels.apparent_power} = ${formatNumber(result)} ${T.units.kva}`;
  } else if (u === null) {
    result = (s * 1000) / i;
    if (!checkResult(E, result)) return;
    setCalculatedField('ac_apparent_u', result);
    text = `${T.labels.voltage} = ${formatNumber(result)} ${T.units.volt}`;
  } else {
    result = (s * 1000) / u;
    if (!checkResult(E, result)) return;
    setCalculatedField('ac_apparent_i', result);
    text = `${T.labels.current} = ${formatNumber(result)} ${T.units.ampere}`;
  }
  showResult('ac_apparent_result', text, '');
}

// Gemeinsame Rechnung für P = U × I × cos φ und Q = U × I × sin φ (einphasig: k = 1, Drehstrom: k = √3)
function calculateUiFactor(cfg) {
  const E = cfg.errorId;
  startCalculation(cfg.calculatorId, E, cfg.resultId);
  const pw = readField(cfg.powerField), u = readField(cfg.voltageField), i = readField(cfg.currentField), f = readField(cfg.factorField);
  const k = cfg.k;

  if (!checkOneEmpty(E, [pw, u, i, f])) return;
  if (!checkInputs(E, [[pw, gtZero, cfg.powerError], [u, gtZero, 'voltage_gt_zero'], [i, gtZero, 'current_gt_zero'], [f, factorRange, cfg.factorRangeError]])) return;

  let result, text;
  if (pw === null) {
    result = (u * i * f * k) / 1000;
    if (!checkResult(E, result)) return;
    setCalculatedField(cfg.powerField, result);
    text = `${cfg.powerLabel} = ${formatNumber(result)} ${cfg.powerUnit}`;
  } else if (u === null) {
    result = (pw * 1000) / (i * f * k);
    if (!checkResult(E, result)) return;
    setCalculatedField(cfg.voltageField, result);
    text = `${T.labels.voltage} = ${formatNumber(result)} ${T.units.volt}`;
  } else if (i === null) {
    result = (pw * 1000) / (u * f * k);
    if (!checkResult(E, result)) return;
    setCalculatedField(cfg.currentField, result);
    text = `${T.labels.current} = ${formatNumber(result)} ${T.units.ampere}`;
  } else {
    result = (pw * 1000) / (u * i * k);
    if (result > 1) return rechnerFail(E, cfg.factorGt1Error);
    if (!checkResult(E, result)) return;
    setCalculatedField(cfg.factorField, result, 3);
    text = `${cfg.factorLabel} = ${formatNumber(result, 3)}`;
  }
  showResult(cfg.resultId, text, '');
}

// Gemeinsame Rechnung für cos φ = P / S und sin φ = Q / S
function calculateFactorRatio(cfg) {
  const E = cfg.errorId;
  startCalculation(cfg.calculatorId, E, cfg.resultId);
  const f = readField(cfg.factorField), pw = readField(cfg.powerField), s = readField(cfg.apparentField);

  if (!checkOneEmpty(E, [f, pw, s])) return;
  if (!checkInputs(E, [[f, factorRange, cfg.factorRangeError], [pw, gtZero, cfg.powerError], [s, gtZero, 'apparent_gt_zero']])) return;

  let result, text;
  if (f === null) {
    if (pw > s) return rechnerFail(E, cfg.powerGtApparentError);
    result = pw / s;
    if (!checkResult(E, result)) return;
    setCalculatedField(cfg.factorField, result, 3);
    text = `${cfg.factorLabel} = ${formatNumber(result, 3)}`;
  } else if (pw === null) {
    result = f * s;
    if (!checkResult(E, result)) return;
    setCalculatedField(cfg.powerField, result);
    text = `${cfg.powerLabel} = ${formatNumber(result)} ${cfg.powerUnit}`;
  } else {
    result = pw / f;
    if (!checkResult(E, result)) return;
    setCalculatedField(cfg.apparentField, result);
    text = `${T.labels.apparent_power} = ${formatNumber(result)} ${T.units.kva}`;
  }
  showResult(cfg.resultId, text, '');
}

const FACTOR_ACTIVE = () => ({ powerError: 'power_gt_zero', factorRangeError: 'cos_phi_range', factorGt1Error: 'cos_phi_gt_1', powerGtApparentError: 'p_gt_s', powerLabel: T.labels.active_power, powerUnit: T.units.kilowatt, factorLabel: T.labels.cos_phi });
const FACTOR_REACTIVE = () => ({ powerError: 'greater_zero', factorRangeError: 'sin_phi_range', factorGt1Error: 'sin_phi_gt_1', powerGtApparentError: 'q_gt_s', powerLabel: T.labels.reactive_power, powerUnit: T.units.kvar, factorLabel: T.labels.sin_phi });

// 6. AC ACTIVE POWER: P = U × I × cos φ
function calculateAcActivePower() {
  calculateUiFactor({ ...FACTOR_ACTIVE(), k: 1, calculatorId: 'ac_active_power', errorId: 'ac_active_error', resultId: 'ac_active_result',
    powerField: 'ac_active_p', voltageField: 'ac_active_u', currentField: 'ac_active_i', factorField: 'ac_active_cos' });
}

// 6a. AC REACTIVE POWER: Q = U × I × sin φ
function calculateAcReactivePower() {
  calculateUiFactor({ ...FACTOR_REACTIVE(), k: 1, calculatorId: 'ac_reactive_power', errorId: 'ac_reactive_error', resultId: 'ac_reactive_result',
    powerField: 'ac_reactive_q', voltageField: 'ac_reactive_u', currentField: 'ac_reactive_i', factorField: 'ac_reactive_sin' });
}

// 6b. AC POWER FACTOR: cos φ = P / S
function calculateAcPowerFactor() {
  calculateFactorRatio({ ...FACTOR_ACTIVE(), calculatorId: 'ac_power_factor', errorId: 'ac_power_factor_error', resultId: 'ac_power_factor_result',
    factorField: 'ac_power_factor_cos', powerField: 'ac_power_factor_p', apparentField: 'ac_power_factor_s' });
}

// 6c. AC REACTIVE FACTOR: sin φ = Q / S
function calculateAcReactiveFactor() {
  calculateFactorRatio({ ...FACTOR_REACTIVE(), calculatorId: 'ac_reactive_factor', errorId: 'ac_reactive_factor_error', resultId: 'ac_reactive_factor_result',
    factorField: 'ac_reactive_factor_sin', powerField: 'ac_reactive_factor_q', apparentField: 'ac_reactive_factor_s' });
}

// 7. THREE PHASE APPARENT POWER: S = U × I × √3
function calculateThreePhaseApparentPower() {
  const E = 'three_apparent_error';
  startCalculation('three_phase_apparent_power', E, 'three_apparent_result');
  const s = readField('three_apparent_s'), u = readField('three_apparent_u'), i = readField('three_apparent_i');
  const sqrt3 = Math.sqrt(3);

  if (!checkOneEmpty(E, [s, u, i])) return;
  if (!checkInputs(E, [[s, gtZero, 'apparent_gt_zero'], [u, gtZero, 'voltage_gt_zero'], [i, gtZero, 'current_gt_zero']])) return;

  let result, text;
  if (s === null) {
    result = (u * i * sqrt3) / 1000;
    if (!checkResult(E, result)) return;
    setCalculatedField('three_apparent_s', result);
    text = `${T.labels.apparent_power} = ${formatNumber(result)} ${T.units.kva}`;
  } else if (u === null) {
    result = (s * 1000) / (i * sqrt3);
    if (!checkResult(E, result)) return;
    setCalculatedField('three_apparent_u', result);
    text = `${T.labels.voltage} = ${formatNumber(result)} ${T.units.volt}`;
  } else {
    result = (s * 1000) / (u * sqrt3);
    if (!checkResult(E, result)) return;
    setCalculatedField('three_apparent_i', result);
    text = `${T.labels.current} = ${formatNumber(result)} ${T.units.ampere}`;
  }
  showResult('three_apparent_result', text, '');
}

// 8. THREE PHASE ACTIVE POWER: P = U × I × cos φ × √3
function calculateThreePhaseActivePower() {
  calculateUiFactor({ ...FACTOR_ACTIVE(), k: Math.sqrt(3), calculatorId: 'three_phase_active_power', errorId: 'three_active_error', resultId: 'three_active_result',
    powerField: 'three_active_p', voltageField: 'three_active_u', currentField: 'three_active_i', factorField: 'three_active_cos' });
}

// 9. THREE PHASE REACTIVE POWER: Q = U × I × sin φ × √3
function calculateThreePhaseReactivePower() {
  calculateUiFactor({ ...FACTOR_REACTIVE(), k: Math.sqrt(3), calculatorId: 'three_phase_reactive_power', errorId: 'three_reactive_error', resultId: 'three_reactive_result',
    powerField: 'three_reactive_q', voltageField: 'three_reactive_u', currentField: 'three_reactive_i', factorField: 'three_reactive_sin' });
}

// 10. POWER FACTOR: cos φ = P / S
function calculatePowerFactor() {
  calculateFactorRatio({ ...FACTOR_ACTIVE(), calculatorId: 'three_phase_power_factor', errorId: 'power_factor_error', resultId: 'power_factor_result',
    factorField: 'power_factor_cos', powerField: 'power_factor_p', apparentField: 'power_factor_s' });
}

// 11. REACTIVE FACTOR: sin φ = Q / S
function calculateReactiveFactor() {
  calculateFactorRatio({ ...FACTOR_REACTIVE(), calculatorId: 'three_phase_reactive_factor', errorId: 'reactive_factor_error', resultId: 'reactive_factor_result',
    factorField: 'reactive_factor_sin', powerField: 'reactive_factor_q', apparentField: 'reactive_factor_s' });
}

// Gemeinsame Rechnung Kabelquerschnitt: A = (c × I × L × cos φ) / (K × Δu × U)
// Gleichstrom: c = 2, ohne cos φ · Wechselstrom: c = 2 · Drehstrom: c = √3
function calculateCable(cfg) {
  const E = cfg.errorId;
  startCalculation(cfg.calculatorId, E, cfg.resultId);
  const id = cfg.prefix;
  const a = readField(`${id}_a`), i = readField(`${id}_i`), l = readField(`${id}_l`);
  const k = readField(`${id}_k`), du = readField(`${id}_du`), u = readField(`${id}_u`);
  const hasCos = cfg.withCos;
  const cosPhi = hasCos ? readField(`${id}_cos`) : 1;
  const c = cfg.c;

  if (!checkOneEmpty(E, hasCos ? [a, i, l, cosPhi, k, du, u] : [a, i, l, k, du, u])) return;
  if (!checkInputs(E, [
    [a, gtZero, 'greater_zero'], [i, gtZero, 'current_gt_zero'], [l, gtZero, 'greater_zero'],
    [hasCos ? cosPhi : 1, factorRange, 'cos_phi_range'], [k, gtZero, 'greater_zero'],
    [du, percentRange, 'voltage_drop_range'], [u, gtZero, 'voltage_gt_zero']
  ])) return;

  const d = du === null ? null : du / 100;
  let result, text, field, decimals = 2;
  if (a === null) {
    result = (c * i * l * cosPhi) / (k * d * u);
    field = 'a'; text = r => `${T.labels.cross_section} = ${formatNumber(r)} ${T.units.mm2}`;
  } else if (i === null) {
    result = (a * k * d * u) / (c * l * cosPhi);
    field = 'i'; text = r => `${T.labels.max_current} = ${formatNumber(r)} ${T.units.ampere}`;
  } else if (l === null) {
    result = (a * k * d * u) / (c * i * cosPhi);
    field = 'l'; text = r => `${T.labels.max_length} = ${formatNumber(r)} ${T.units.meter}`;
  } else if (du === null) {
    result = ((c * i * l * cosPhi) / (a * k * u)) * 100;
    if (result > 100) return rechnerFail(E, 'voltage_drop_range');
    field = 'du'; text = r => `${T.labels.voltage_drop} = ${formatNumber(r)} ${T.units.percent}`;
  } else if (u === null) {
    result = (c * i * l * cosPhi) / (a * k * d);
    field = 'u'; text = r => `${T.labels.voltage} = ${formatNumber(r)} ${T.units.volt}`;
  } else if (k === null) {
    result = (c * i * l * cosPhi) / (a * d * u);
    field = 'k'; text = r => `${T.labels.conductivity} = ${formatNumber(r)} ${T.units.conductivity}`;
  } else {
    result = (a * k * d * u) / (c * i * l);
    if (result > 1) return rechnerFail(E, 'cos_phi_gt_1');
    field = 'cos'; decimals = 3; text = r => `${T.labels.cos_phi} = ${formatNumber(r, 3)}`;
  }

  if (!checkResult(E, result)) return;
  setCalculatedField(`${id}_${field}`, result, decimals);
  showResult(cfg.resultId, text(result), '');
}

// 12. CABLE DC: A = (2 × I × L) / (K × Δu × U)
function calculateCableDc() {
  calculateCable({ calculatorId: 'cable_dc', errorId: 'cable_dc_error', resultId: 'cable_dc_result', prefix: 'cable_dc', c: 2, withCos: false });
}

// 13. CABLE AC: A = (2 × I × L × cosφ) / (K × Δu × U)
function calculateCableAc() {
  calculateCable({ calculatorId: 'cable_ac', errorId: 'cable_ac_error', resultId: 'cable_ac_result', prefix: 'cable_ac', c: 2, withCos: true });
}

// 14. CABLE THREE PHASE: A = (√3 × I × L × cosφ) / (K × Δu × U)
function calculateCableThreePhase() {
  calculateCable({ calculatorId: 'cable_three_phase', errorId: 'cable_three_error', resultId: 'cable_three_result', prefix: 'cable_three', c: Math.sqrt(3), withCos: true });
}

// 15. TORQUE: Md = 9550 × P / n
function calculateTorque() {
  const E = 'torque_error';
  startCalculation('torque', E, 'torque_result');
  const md = readField('torque_md'), p = readField('torque_p'), n = readField('torque_n');

  if (!checkOneEmpty(E, [md, p, n])) return;
  if (!checkInputs(E, [[md, gtZero, 'torque_gt_zero'], [p, gtZero, 'power_gt_zero'], [n, gtZero, 'speed_gt_zero']])) return;

  let result, text;
  if (md === null) {
    result = (9550 * p) / n;
    if (!checkResult(E, result)) return;
    setCalculatedField('torque_md', result);
    text = `${T.labels.torque} = ${formatNumber(result)} ${T.units.newton_meter}`;
  } else if (p === null) {
    result = (md * n) / 9550;
    if (!checkResult(E, result)) return;
    setCalculatedField('torque_p', result);
    text = `${T.labels.power} = ${formatNumber(result)} ${T.units.kilowatt}`;
  } else {
    result = (9550 * p) / md;
    if (!checkResult(E, result)) return;
    setCalculatedField('torque_n', result, 0);
    text = `${T.labels.speed} = ${formatNumber(result, 0)} ${T.units.rpm}`;
  }
  showResult('torque_result', text, '');
}

// 16. SLIP: S = (Ns - N) / Ns × 100%
function calculateSlip() {
  const E = 'slip_error';
  startCalculation('slip', E, 'slip_result');
  const s = readField('slip_s'), ns = readField('slip_ns'), n = readField('slip_n');

  if (!checkOneEmpty(E, [s, ns, n])) return;
  if (!checkInputs(E, [[s, gtZero, 'greater_zero'], [s, v => v < 100, 'slip_lt_100'], [ns, gtZero, 'sync_speed_gt_zero'], [n, gtZero, 'speed_gt_zero']])) return;

  let result, text;
  if (s === null) {
    result = ((ns - n) / ns) * 100;
    if (!checkResult(E, result)) return;
    setCalculatedField('slip_s', result);
    text = `${T.labels.slip} = ${formatNumber(result)} ${T.units.percent}`;
  } else if (n === null) {
    result = ns * (1 - s / 100);
    if (!checkResult(E, result)) return;
    setCalculatedField('slip_n', result, 0);
    text = `${T.labels.rotor_speed} = ${formatNumber(result, 0)} ${T.units.rpm}`;
  } else {
    result = n / (1 - s / 100);
    if (!checkResult(E, result)) return;
    setCalculatedField('slip_ns', result, 0);
    text = `${T.labels.sync_speed} = ${formatNumber(result, 0)} ${T.units.rpm}`;
  }
  showResult('slip_result', text, '');
}

// 17. ENERGY SAVING
function calculateEnergySaving() {
  const E = 'energy_error';
  hideError(E);
  hideResult('energy_result');

  const p = readField('energy_p');
  const hours = readField('energy_hours');
  const effOld = readField('energy_eff_old');
  const effNew = readField('energy_eff_new');
  const price = readField('energy_price');
  const cost = readField('energy_cost');

  if ([p, hours, effOld, effNew, price, cost].some(v => v === null)) return rechnerFail(E, 'missing_inputs');
  if (!checkInputs(E, [
    [p, gtZero, 'power_gt_zero'], [hours, gtZero, 'time_gt_zero'],
    [effOld, percentRange, 'efficiency_range'], [effNew, percentRange, 'efficiency_range'],
    [price, gtZero, 'greater_zero'], [cost, gtZero, 'greater_zero']
  ])) return;
  if (effNew <= effOld) return rechnerFail(E, 'eff_new_gt_old');

  // Energieverbrauch pro Jahr (kWh)
  const consumptionOld = (p / (effOld / 100)) * hours;
  const consumptionNew = (p / (effNew / 100)) * hours;
  const savingKwh = consumptionOld - consumptionNew;
  const savingCost = savingKwh * price;
  const paybackTime = cost / savingCost;
  if (![savingKwh, savingCost, paybackTime].every(v => checkResult(E, v))) return;

  const resultText = `
    <p><strong>${T.energy.annual_saving}:</strong> ${formatNumber(savingKwh, 0)} kWh</p>
    <p><strong>${T.energy.cost_saving}:</strong> ${formatNumber(savingCost, 2)} €</p>
    <p><strong>${T.energy.payback}:</strong> ${formatNumber(paybackTime, 1)} ${T.energy.years}</p>
  `;

  const resultBox = document.getElementById('energy_result');
  resultBox.querySelector('.result-value').innerHTML = resultText;
  resultBox.classList.add('active');
}

// 18. OHMS LAW: U = I × R
function calculateOhmsLaw() {
  const E = 'ohms_error';
  startCalculation('ohms_law', E, 'ohms_result');
  const u = readField('ohms_u'), i = readField('ohms_i'), r = readField('ohms_r');

  if (!checkOneEmpty(E, [u, i, r])) return;
  if (!checkInputs(E, [[u, gtZero, 'voltage_gt_zero'], [i, gtZero, 'current_gt_zero'], [r, gtZero, 'resistance_gt_zero']])) return;

  let result, text;
  if (u === null) {
    result = i * r;
    if (!checkResult(E, result)) return;
    setCalculatedField('ohms_u', result);
    text = `${T.labels.voltage} = ${formatNumber(result)} ${T.units.volt}`;
  } else if (i === null) {
    result = u / r;
    if (!checkResult(E, result)) return;
    setCalculatedField('ohms_i', result);
    text = `${T.labels.current} = ${formatNumber(result)} ${T.units.ampere}`;
  } else {
    result = u / i;
    if (!checkResult(E, result)) return;
    setCalculatedField('ohms_r', result);
    text = `${T.labels.resistance} = ${formatNumber(result)} ${T.units.ohm}`;
  }
  showResult('ohms_result', text, '');
}

// Reset-Handler: Beim Zurücksetzen auch Ergebnis/Fehler-Boxen und berechnete Felder zurücksetzen
document.querySelectorAll('.calculator-form').forEach(form => {
  form.addEventListener('reset', function() {
    const calculator = form.closest('.rechner-calculator');
    if (calculator) {
      setTimeout(() => {
        calculator.querySelectorAll('.result-box').forEach(b => b.classList.remove('active'));
        calculator.querySelectorAll('.error-box').forEach(b => b.classList.remove('active'));
        calculator.querySelectorAll('.form-control.calculated').forEach(f => f.classList.remove('calculated'));
      }, 10);
    }
  });
});

console.log('✅ Online-Rechner geladen - Alle Rechner bereit mit Formelumstellung!');
